import { Component, OnInit, Input } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { FoodService } from 'app/services';
import { FoodProductStatus } from 'app/models';

enum EditModifierGroupTab {
    GroupInfo = 1,
    Modifiers = 2
}

@Component({
    selector: 'edit-food-modifier-group',
    templateUrl: './edit-food-modifier-group.component.html',
    styleUrls: ['./edit-food-modifier-group.component.scss'],
    providers: [MessageService]
})
export class EditFoodModifierGroupComponent implements OnInit {
    @Input()
    public modifierGroupId: number = 0;

    @Input()
    public restaurants: Array<any> = [];

    @Input()
    public onSave: () => void = () => { };

    @Input()
    public onHide: () => void = () => { };

    public editModifierGroupTab = EditModifierGroupTab;
    public activeTab: EditModifierGroupTab = EditModifierGroupTab.GroupInfo;

    public menuItems: MenuItem[] = [
        {
            label: 'Modifier Group',
            id: `${EditModifierGroupTab.GroupInfo}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        },
        {
            label: 'Modifiers',
            id: `${EditModifierGroupTab.Modifiers}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        }
    ];

    public modifierGroup: any = {};

    public isEnabled: boolean = true;

    public allModifiers: Array<any> = [];
    public freeModifiers: Array<any> = [];
    public groupModifiers: Array<any> = [];
    public groupModifiersChanged: boolean = false;

    public cols: any[] = [
        { field: 'Id', header: 'Id', width: '90px' },
        { field: 'Name', header: 'Name', width: '200px' },
        { field: 'ImageUrl', header: 'Image', width: '200px', disableSort: true }
    ];

    constructor(
        private messageService: MessageService,
        private foodService: FoodService) {
    }

    ngOnInit(): void {
        if (this.modifierGroupId) {
            this.getModifierGroup();
        }
    }

    private getModifierGroup(): void {
        const dto = {
            Id: this.modifierGroupId
        };

        this.foodService.getModifierGroupById(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.modifierGroup = data;

                this.isEnabled = this.modifierGroup.StatusId === FoodProductStatus.Enabled;

                this.getGroupModifiers();
            });
    }

    private getAllModifiers(): void {
        if (!this.modifierGroup.RestaurantId) {
            return;
        }

        const dto = {
            RestaurantId: this.modifierGroup.RestaurantId
        };

        this.foodService.getModifiers(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.allModifiers = data.ModifierList;

                this.filterFreeModifiers();
            });
    }

    private getGroupModifiers(): void {
        const dto = {
            RestaurantId: this.modifierGroup.RestaurantId,
            ModifierGroupId: this.modifierGroup.Id
        };

        this.foodService.getModifiers(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.groupModifiers = data.ModifierList;
            });
    }

    private filterFreeModifiers(): void {
        this.freeModifiers = [];

        for (const modifier of this.allModifiers) {
            if (!this.groupModifiers.some(x => x.Id === modifier.Id)) {
                this.freeModifiers.push(modifier);
            }
        }
    }

    public handleModifierSelected(evt: any): void {
        for (const modifier of this.allModifiers) {
            if (modifier.Id === evt.value) {
                this.groupModifiers.push(modifier);
                break;
            }
        }

        this.groupModifiersChanged = true;

        this.filterFreeModifiers();
    }

    public handleDeleteModifierClick(modifier: any): void {
        const index = this.groupModifiers.indexOf(modifier);

        if (index !== -1) {
            this.groupModifiers.splice(index, 1);
        }

        this.groupModifiersChanged = true;

        this.filterFreeModifiers();
    }

    public handleSideBarHide(): void {
        this.onHide();
    }

    public handleTabChange(tab: EditModifierGroupTab) {
        this.activeTab = tab;

        if (tab === EditModifierGroupTab.Modifiers) {
            if (!this.allModifiers.length) {
                this.getAllModifiers();
            }
        }
    }

    public handleSaveClick(): void {
        let promise: Promise<any> = Promise.resolve();

        this.modifierGroup.StatusId = this.isEnabled ? FoodProductStatus.Enabled : FoodProductStatus.Disabled;

        if (this.groupModifiersChanged) {
            this.modifierGroup.ModifierIds = this.groupModifiers.map(x => x.Id);
        }

        if (this.modifierGroupId) {
            promise = this.foodService.updateModifierGroup(this.modifierGroup, this.messageService);
        } else {
            promise = this.foodService.addModifierGroup(this.modifierGroup, this.messageService);
        }

        promise.then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }

            this.onSave();
        });
    }
}
